import { ErrorHandler, Injectable } from "@angular/core";
import { Functions, httpsCallable } from "@angular/fire/functions";
import { debounceTime, Subject, take } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CustomErrorHandler implements ErrorHandler {
  readonly error$ = new Subject<Error>();

  constructor(
    private readonly functions: Functions,
  ) {

    this.error$.pipe(debounceTime(1000), take(20)).subscribe(async error => {
      this.reportError(error);
    });
  }

  async handleError(error: Error) {
    console.error('Uncaught error:', error);

    if(error?.message?.includes('Failed to fetch dynamically imported module') || error?.message?.includes('Importing a module script failed')) {
      window.location.reload();
      return;
    }

    this.error$.next(error);
  }

  private async reportError(error: Error) {
    const url = window.location.toString();
    let message = error?.message || '(no error message)';
    if(message && typeof message !== 'string') {
      try {
        message = JSON.stringify(message);
      } catch (e2) {}
    }

    const stackTrace = error?.stack || '(no stack trace)';
    const userAgent = window.navigator.userAgent || '(unknown user agent)';

    try {
      await httpsCallable<{}, string>(this.functions, 'reportJsError')({url, message, stackTrace, userAgent});
    } catch (e2) {
      console.warn('Failed to report error', e2);
    }
  }
}
